export var InspectionStatusEnums;
(function (InspectionStatusEnums) {
    InspectionStatusEnums["TODO"] = "ToDo";
    InspectionStatusEnums["ONGOING"] = "Ongoing";
    InspectionStatusEnums["APPROVED"] = "Approved";
    InspectionStatusEnums["APPROVED_WITH_REMARKS"] = "ApprovedWithRemarks";
    InspectionStatusEnums["NOT_APPROVED"] = "NotApproved";
    InspectionStatusEnums["CANCELLED"] = "Cancelled";
    InspectionStatusEnums["OVERDUE"] = "Overdue";
    InspectionStatusEnums["FINISHED"] = "Finished";
})(InspectionStatusEnums || (InspectionStatusEnums = {}));
//# sourceMappingURL=InspectionStatusEnums.js.map